import React from 'react';
import { IconButton } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import SyncIcon from '@mui/icons-material/Sync';
import OnedriveLogo from 'src/assets/storageIcons/onedrive.png';
import OnedriveLogoDisconnected from 'src/assets/storageIcons/onedrive_disconnected.png';

import LinkIcon from '@mui/icons-material/Link';
import ErrorIcon from '@mui/icons-material/Error';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import { getServiceStatus, syncService } from 'src/services/service.service';
import { loginRequest } from 'src/config/msal.config';
import { getToken } from 'src/services/auth.service';
import { ReactWebStore } from 'react-webstore';

// ----------------------------------------------------------------------

class OnedriveStatusAndSync extends React.Component {
  
  constructor(props) {
    super(props);

    this.rws = new ReactWebStore();
    this.state = {
      connected: false,
      sync_status: null,
      serviceId: props?.serviceId || '',
      displayType: props?.displayType || 'standard',
      loading: false,
      errored: false,
    }

  }

  async componentDidMount() {
    this.checkStatusPeriodically();
  }

  sync = async () => {
    this.setState({ sync_status: 'syncing' });
    this.rws.store('sync_organizing_status', 'success');
    let res = await syncService(this.state.serviceId);
    if (res.error) {
      this.setState({ sync_status: null });
      return;
    }
    this.checkStatusPeriodically();
  }

  checkStatusPeriodically = async () => {

    this.setState({
      loading: true,
      errored: false,
    });


    let serviceStatusRes = await getServiceStatus(this.state.serviceId);

    if (serviceStatusRes.error) {
      this.setState({
        loading: false,
        errored: true,
      });
      return;
    }

    if (serviceStatusRes.sync_status === 'syncing') {
      // Check if syncing since 2 hours
      if (!serviceStatusRes.sync_started_at) {
        serviceStatusRes.sync_status = null;
      }

      let syncStartedAt = new Date(serviceStatusRes.sync_started_at);
      let now = new Date();
      let diffInMs = now - syncStartedAt;
      let diffInHours = diffInMs / (1000 * 60 * 60);
      if (diffInHours >= 2) {
        serviceStatusRes.sync_status = null;
      }

    }

    this.setState({
      connected: serviceStatusRes.connected || false,
      sync_status: serviceStatusRes.sync_status || null,
      loading: false,
      errored: false,
    });

    if (serviceStatusRes.sync_status !== 'syncing') {
      return;
    }

    this.rws.store('sync_organizing_status', 'success');
    setTimeout(() => {
      this.checkStatusPeriodically();
    }, 10000);

  }

  render() {

    if (this.state.loading) {
        return (
            <IconButton aria-label="loading" disabled>
                <HourglassEmptyIcon fontSize='small' />
            </IconButton>
        );
    }

    if (this.state.errored) {
      if (this.state.displayType === 'standard') {
        return (
            <IconButton aria-label="error"
              onClick={() => {
                window.location.href = `https://login.microsoftonline.com/common/oauth2/v2.0/authorize?client_id=${process.env.REACT_APP_ONEDRIVE_CLIENT_ID}&response_type=code&redirect_uri=${encodeURIComponent(process.env.REACT_APP_ONEDRIVE_CALLBACK_URL)}&response_mode=query&scope=${encodeURIComponent(loginRequest.scopes.join(' '))}&prompt=select_account&state=${JSON.stringify({ token: getToken() })}`;
              }}
            >
                <ErrorIcon style={{ color: 'red' }} />
            </IconButton>
        );
      } else {
        return (
          <IconButton aria-label="disconnected"
            onClick={() => {
              window.location.href = `https://login.microsoftonline.com/common/oauth2/v2.0/authorize?client_id=${process.env.REACT_APP_ONEDRIVE_CLIENT_ID}&response_type=code&redirect_uri=${encodeURIComponent(process.env.REACT_APP_ONEDRIVE_CALLBACK_URL)}&response_mode=query&scope=${encodeURIComponent(loginRequest.scopes.join(' '))}&prompt=select_account&state=${JSON.stringify({ token: getToken() })}`;
            }}
          >
            <img src={OnedriveLogoDisconnected} style={{width: '25px', height: 'auto'}} />
          </IconButton>
        );
      }
    }


    if (this.state.displayType === 'standard') {
      return (
        <>
          {(this.state.connected) ? (
            <IconButton aria-label="sync"
              onClick={async () => {
                this.sync();
              }}
              disabled={this.state.sync_status === 'syncing'}
            >
              <SyncIcon fontSize='small' style={this.state.sync_status === 'syncing' ? { animation: 'spin 2s linear infinite reverse' } : {}} />
            </IconButton>
          ) : (
            <IconButton aria-label="disconnected"
              onClick={() => {
                window.location.href = `https://login.microsoftonline.com/common/oauth2/v2.0/authorize?client_id=${process.env.REACT_APP_ONEDRIVE_CLIENT_ID}&response_type=code&redirect_uri=${encodeURIComponent(process.env.REACT_APP_ONEDRIVE_CALLBACK_URL)}&response_mode=query&scope=${encodeURIComponent(loginRequest.scopes.join(' '))}&prompt=select_account&state=${JSON.stringify({ token: getToken() })}`;
              }}
            >
              <LinkIcon
                fontSize='small'
              />
            </IconButton>
          )}
        </>
      );
    } else {
      return (
        <>
          {(this.state.connected) ? (
            <IconButton aria-label="connected-sync"
              onClick={async () => {
                this.sync();
              }}
              disabled={this.state.sync_status === 'syncing'}
            >
              {this.state.sync_status === 'syncing' ? (
                <SyncIcon fontSize='small' style={{ animation: 'spin 2s linear infinite reverse' }} />
              ) : (
                <img src={OnedriveLogo} style={{width: '25px', height: 'auto'}} />
              )}
            </IconButton>
          ) : (
            <IconButton aria-label="disconnected"
              onClick={() => {
                window.location.href = `https://login.microsoftonline.com/common/oauth2/v2.0/authorize?client_id=${process.env.REACT_APP_ONEDRIVE_CLIENT_ID}&response_type=code&redirect_uri=${encodeURIComponent(process.env.REACT_APP_ONEDRIVE_CALLBACK_URL)}&response_mode=query&scope=${encodeURIComponent(loginRequest.scopes.join(' '))}&prompt=select_account&state=${JSON.stringify({ token: getToken() })}`;
              }}
            >
              <img src={OnedriveLogoDisconnected} style={{width: '25px', height: 'auto'}} />
            </IconButton>
          )}
        </>
      );
    }
  }
}

export default function (props) {
    const navigate = useNavigate();
    return <OnedriveStatusAndSync {...props} navigate={navigate} />;
}
